import * as UiUtil from "@/util/UiUtil";

export const getFieldLabel = () => {
  const domain = window.location.hostname;
  switch (domain) {
  case "ep.maot.co.kr":
    return "작업장명";
  case "nhsafe.maot.co.kr":
    return "현장명";
  default:
    return "사업장명";
  }
};

import config from "../../public/config";
import VueCookie from "vue-cookie";

export const downloadFile = (fileName, path) => {
  const hashedFileName = path.split("/").pop();

  const token = VueCookie.get("token");
  fetch(`${config.BASE_API_URL}/api/v1/file?hashedName=${hashedFileName}`, {
    headers: new Headers({
      Authorization: `Bearer ${token}`,
    }),
  }).then((response) => {
    response.blob().then((myBlob) => {
      const url = window.URL.createObjectURL(myBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });
  });
};

let _loadDefragmentation_list = [];
const _loadDefragmentation = async ($store, apiType, options, useLoading) => {
  const response = await $store.dispatch(apiType, options);
  const list = [];
  list.push(...response.data);
  _loadDefragmentation_list.push(...response.data);
  if (useLoading) {
    UiUtil.loading(true, _loadDefragmentation_list.length, response.total);
  }
  if (response.current_page !== response.last_page) {
    options.page = response.current_page + 1;
    const _list = await _loadDefragmentation($store, apiType, options, useLoading);
    list.push(..._list);
    _loadDefragmentation_list.push(..._list);
  }
  return list
};

/**
 * 모든 페이지의 데이터를 불러온다.
 * @param $store
 * @param apiType
 * @param options
 * @returns {Promise<*[]>}
 */
export async function loadDefragmentation($store, apiType, options, useLoading) {
  _loadDefragmentation_list = [];
  if (useLoading) {
    UiUtil.loading(true);
  }
  const list = await _loadDefragmentation($store, apiType, options, useLoading)
  if (useLoading) {
    UiUtil.loading(false);
  }
  return list;
}

export function comma(str) {
  return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
